(function() {
  angular.module('cfn').factory('seedPlanningModel', seedPlanningModel);

  seedPlanningModel.$inject = ['$log', '$http', '$q', '$timeout'];

  function seedPlanningModel($log, $http, $q, $timeout) {
    // Delay before planning is saved
    var saveTimeoutTime = 5000;
    // Current $timeout after which planning will be saved
    var saveTimeout;
    // List of cultures available in system
    var sysCultures = [];
    // Identification of currently loaded planning
    var savedHarvestYear;
    var savedCultureId;
    // Planning as stored on server
    var savedPlanning;
    // Planning as stored on client
    var planningToSave;

    let URL = {
      seedplanning: '/365FarmNet/mod/crop-planning-service/rest/planning/seed/v1.0/'
    };
  
    var getResourceUrl = function(harvestYear, cultureId) {
      return (
        URL.seedplanning +
        harvestYear +
        '/' +
        cultureId
      );
    };
    /**
     * Remove attributes that are not important while saving
     */
    var toSaveModel = function(viewModel) {
      var serverModel = $.extend(true, {}, viewModel);

      // Read only values
      delete serverModel.sysCulture;
      delete serverModel.seedStrengthUnitOptions;

      serverModel.rows.forEach(function(row) {
        // Frontend calculated values
        delete row.view;
        // Read only values
        row.field = { id: row.field.id };
        delete row.previousCrop1st;
        delete row.previousCrop2nd;
        delete row.previousCrop3rd;
        delete row.plannedArea;
        delete row.seedsReadOnly;
      });

      serverModel.seedColumns.forEach(function(row, idx) {
        serverModel.seedColumns[idx] = { id: row.id };
      });

      return serverModel;
    };
    /**
     * Actually saves a given planning to the server
     */
    var savePlanning = function(harvestYear, cultureId, saveModel) {
      $log.debug('Saving planning');
      var planningUrl = getResourceUrl(harvestYear, cultureId);
      return $http.put(planningUrl, saveModel);
    };
    /**
     * Saves a pending planning if neccesary
     *
     * @return promise, resolved if ready
     */
    var flushSave = function() {
      if (saveTimeout) {
        return savePlanning(savedHarvestYear, savedCultureId, planningToSave);
      } else {
        // Nothing to save
        return $q.when();
      }
    };

    /* Public methods */
    return {
      init: function() {
        $log.debug('Loading cultures');
        return $http
          .get('/365FarmNet/rest/core/sysculture')
          .then(function(response) {
            $log.debug('Cultures loaded');
            sysCultures = response.data;
          });
      },

      loadSeed: function(seedId) {
        var seedPromise = $q.defer();

        $log.debug('Loading seed');
        $http
          .get('/365FarmNet/rest/core/seed/' + seedId)
          .then(function(response) {
            $log.debug('Seed loaded');
            seedPromise.resolve(response.data.seed);
          });

        return seedPromise.promise;
      },

      loadSeeds: function() {
        var seedsPromise = $q.defer();

        $http
          .get('/365FarmNet/rest/core/seed/ActiveOnly?param=' + savedCultureId)
          .then(function(response) {
            seedsPromise.resolve(response.data);
          });

        return seedsPromise.promise;
      },

      loadAvailableYears: function() {
        var url = '/365FarmNet/rest/analyse/cropoverview/harvestyears';
        return $http({
          method: 'GET',
          url: url
        });
      },

      loadPlannedCultures: function(harvestYear) {
        var cultures = $q.defer();

        // Receives a list of UUID from server. Loads names using sysCultureService
        $http
          .get(
            '/365FarmNet/mod/crop-planning-service/rest/planning/cropsequence/v1.0/' +
              harvestYear +
              '/cultures?forSeedPlanning=true'
          )
          .then(function(response) {
            var listOfIds = response.data;
            var idMap = {};
            listOfIds.forEach(function(id) {
              // Lookup name of the culture
              sysCultures.forEach(function(culture) {
                if (culture.id === id) {
                  idMap[id] = culture.name;
                }
              });
            });

            cultures.resolve(idMap);
          });

        return cultures.promise;
      },

      /**
       * Loads a planning of a given harvest year and culture and remembers the server state
       * for comparison
       */
      loadPlanning: function(harvestYear, cultureId) {
        var result = $q.defer();

        flushSave().then(function() {
          $log.debug('Load planning ' + harvestYear + '/' + cultureId);

          $http
            .get(getResourceUrl(harvestYear, cultureId))
            .then(function(response) {
              var planning = response.data;
              $log.debug('Planning loaded');

              // Save a deep copy
              savedHarvestYear = harvestYear;
              savedCultureId = cultureId;
              savedPlanning = toSaveModel(planning);

              result.resolve(planning);
            });
        });

        return result.promise;
      },

      /**
       * Called on changes of the view model. Auto-saves if relevant fields
       * have been changed.
       */
      onChangedViewModel: function(viewModel) {
        // Compare actual server model
        planningToSave = toSaveModel(viewModel);

        if (angular.equals(planningToSave, savedPlanning)) {
          return;
        }

        $log.debug('Planning changed');

        // Avoid overlapping saves
        if (saveTimeout) {
          $timeout.cancel(saveTimeout);
        }

        saveTimeout = $timeout(flushSave, saveTimeoutTime);
      }
    };
  }
})();
